import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../hooks/useDocumentTitle';
import OwnerOffer from '../components/acquisition/OwnerOffer';
import { appendAttribution, captureAttribution } from '../utils/attribution';
import { trackAcquisitionEvent } from '../utils/acquisitionEvents';
import { getAppSearch } from '../utils/platform';
import { markBrowsing } from '../utils/welcome';
import '../styles/WelcomePage.css';

const FEATURES = [
  {
    icon: '⚡',
    title: 'بضغطة واحدة',
    text: 'احجز موعدك في ثوانٍ — بدون مكالمات ولا انتظار على الهاتف.',
  },
  {
    icon: '📅',
    title: 'كل حجوزاتك في مكان واحد',
    text: 'تابع مواعيدك، أعِد جدولتها، أو ألغِها بسهولة من شاشة واحدة.',
  },
  {
    icon: '💈',
    title: 'أفضل الصالونات',
    text: 'اكتشف الصالونات ومراكز التجميل القريبة منك واختر ما يناسبك.',
  },
];

const OWNER_FEATURES = [
  {
    icon: '🗓️',
    title: 'إدارة المواعيد',
    text: 'نظّم حجوزات صالونك وجدول عملك من لوحة تحكم واحدة سهلة.',
  },
  {
    icon: '👥',
    title: 'عملاؤك دائماً معك',
    text: 'قاعدة عملاء منظّمة مع تذكيرات تلقائية عبر الرسائل تقلّل الغياب.',
  },
  {
    icon: '📈',
    title: 'نمِّ نشاطك',
    text: 'اظهر لآلاف العملاء الباحثين عن الصالونات القريبة منهم.',
  },
];

function WelcomePage() {
  const navigate = useNavigate();
  useDocumentTitle('أدواري — احجز أو أدر صالونك');

  useEffect(() => {
    captureAttribution(getAppSearch());
  }, []);

  const handleStartSearch = () => {
    markBrowsing();
    navigate('/');
  };

  const handleRegisterBusiness = () => {
    trackAcquisitionEvent('registration_selected', '/welcome');
    navigate(appendAttribution('/register-business'));
  };

  return (
    <div className="welcome-page">
      <div className="welcome-inner">
        <header className="welcome-brand">
          <img src="/icons/icon.svg" alt="أدواري" className="welcome-logo" />
        </header>

        <section className="welcome-hero">
          <h1 className="welcome-title">أدواري</h1>
          <p className="welcome-tagline">منصّة حجز مواعيد الصالونات ومراكز التجميل</p>
          <p className="welcome-desc">
            سواء كنت تبحث عن صالون قريب لحجز موعدك، أو صاحب صالون تريد إدارة
            حجوزاتك وعملائك — أدواري يجمع كل ذلك في مكان واحد.
          </p>
        </section>

        <OwnerOffer onRegister={handleRegisterBusiness} />

        <div className="welcome-cta">
          <button type="button" className="btn-primary welcome-cta-btn" onClick={handleStartSearch}>
            ابحث عن صالون واستخدم أدواري
          </button>
        </div>

        <section className="welcome-section-label">لعملائنا الكرام</section>
        <section className="welcome-features">
          {FEATURES.map((f) => (
            <div className="welcome-feature" key={f.title}>
              <span className="welcome-feature-icon" aria-hidden="true">{f.icon}</span>
              <h3 className="welcome-feature-title">{f.title}</h3>
              <p className="welcome-feature-text">{f.text}</p>
            </div>
          ))}
        </section>

        <section className="welcome-section-label">لأصحاب الصالونات ومراكز التجميل</section>
        <section className="welcome-features">
          {OWNER_FEATURES.map((f) => (
            <div className="welcome-feature" key={f.title}>
              <span className="welcome-feature-icon" aria-hidden="true">{f.icon}</span>
              <h3 className="welcome-feature-title">{f.title}</h3>
              <p className="welcome-feature-text">{f.text}</p>
            </div>
          ))}
        </section>

        <div className="welcome-owner-cta">
          <p>هل تملك صالوناً أو مركز تجميل؟</p>
          <button type="button" className="btn-primary" onClick={handleRegisterBusiness}>
            سجّل كصاحب مصلحة الآن
          </button>
        </div>

        <footer className="welcome-footer">
          <Link to="/contact" className="welcome-footer-link">تواصل معنا</Link>
          <Link to="/privacy" className="welcome-footer-link">سياسة الخصوصية</Link>
          <span className="welcome-footer-copy">© {new Date().getFullYear()} أدواري</span>
        </footer>
      </div>
    </div>
  );
}

export default WelcomePage;
